import { render, staticRenderFns } from "./EvolutionChartTab.vue?vue&type=template&id=390cd04d"
import script from "./EvolutionChartTab.vue?vue&type=script&lang=js"
export * from "./EvolutionChartTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports